const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  menulist: state => state.user.menulist,
  hotel_no: state => state.user.hotel_no,
  renter_no: state => state.user.renter_no
};
export default getters;
